import { record, upper, type JanusReaders, type Row } from '../ability/context.js';

/** Shared mounted-payload discovery for cards, moves and fire lifecycle ports. */
export function mountedTrapAbilityIds(host: Row, entries: (row: Row, key: string) => unknown[]): string[] {
  const ids: string[] = [];
  for (const entry of entries(host, 'trap_ability')) {
    const id = upper(typeof entry === 'string' ? entry : record(entry)?.item_id);
    if (id) ids.push(id);
  }
  for (const slot of Array.isArray(host.enchantment_template_enchantments) ? host.enchantment_template_enchantments : []) {
    const row = record(slot);
    if (row?.enchantment_type === 'trap_ability' && upper(row.enchantment_item_id)) ids.push(upper(row.enchantment_item_id));
  }
  return [...new Set(ids)];
}

/** Interaction selection happens before any fire draw, including a walk's exact sensor claim. */
export function selectMountedTrapPayload(host: Row, interaction: string,
  read: Pick<JanusReaders, 'entries' | 'definition'>, onlyId?: string):
  { kind: 'selected'; id: string; definition: Row } | { kind: 'no_fire' } | { kind: 'unmodelled'; reason: string; id: string } {
  for (const id of mountedTrapAbilityIds(host, read.entries)) {
    if (onlyId && id !== upper(onlyId)) continue;
    const definition = read.definition(id);
    if (!definition) return { kind: 'unmodelled', reason: 'payload-not-held', id };
    const triggers = read.entries(definition, 'trap_trigger').map(entry =>
      String(typeof entry === 'string' ? entry : record(entry)?.item_id ?? '').trim().toLowerCase());
    if (interaction === 'remote' || interaction === 'disarm_failure' || triggers.includes(interaction.toLowerCase()))
      return { kind: 'selected', id, definition };
  }
  return { kind: 'no_fire' };
}
